import _ from 'lodash'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import i18n from 'utils/i18n'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { constantsActive } from 'utils/constants/constants'
import React, { useState } from 'react'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import Translate from 'utils/translate'
import { listArrow } from 'styles/list'
import ListItem from 'components/atoms/ListItem'

const BuildingContact = ({ building }) => {
	
	const navigation = useNavigation();
	
	const [ searchValue, setSearchValue ] = useState('')
	
	// Building contacts
	const buildingContacts = _.get( building, 'contacts', [] );
	
	const openContact = ( item= {} ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_BUILDINGS_CONTACT, {
			buildingGuid: building.guid,
			contactGuid: item.guid
		});
	}
	
	const createContact = () => {
		openContact( {} );
	}
	
	const renderContactPersonItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openContact }
			/>
		)
	}
	
	const filtersBuildingContacts = _.size( searchValue ) > 2 ? [ { field: 'name', kind: 'contains', value: searchValue } ] : null;
	
	const headerBuildingContact = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.buildings.building.employee.input_search'),
					onChangeText: _.debounce( setSearchValue, 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDING_CONTACT_PERSONS ) ? { onPress: createContact } : null }
		/>
	);
	
	return (
		<ManagementGroupedThemeList
			header={ headerBuildingContact }
			items={ buildingContacts }
			renderItem={ renderContactPersonItem.bind( this ) }
			groupByKey={ 'active' }
			filters={ filtersBuildingContacts }
			groupByValues={ [
				constantsActive.YES,
				constantsActive.NO
			] }
		/>
	);
}

export default BuildingContact
